/* src/app/modules/shared/components/column/column-quantity-and-size/column-quantity-and-size.component.scss */
app-column-quantity-and-size {
  display: contents;
}
/*# sourceMappingURL=column-quantity-and-size.component.css.map */
